var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
var LoaderIcon = forwardRef(function (_a, ref) {
    var stopAnimation = _a.stopAnimation, className = _a.className, style = _a.style, _b = _a.size, size = _b === void 0 ? "md" : _b, otherProps = __rest(_a, ["stopAnimation", "className", "style", "size"]);
    var combinedClass = "ssg-loader-icon";
    if (size) {
        combinedClass += " ssg-loader-icon--".concat(size);
    }
    if (stopAnimation) {
        combinedClass += " ssg-loader-icon--stop-animation";
    }
    if (className) {
        combinedClass += " ".concat(className);
    }
    return (React.createElement("svg", __assign({}, otherProps, { ref: ref, style: style, className: combinedClass, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }),
        React.createElement("symbol", { id: "ssg-loader-icon__circle1" },
            React.createElement("path", { d: "M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3z" })),
        React.createElement("symbol", { id: "ssg-loader-icon__circle2" },
            React.createElement("path", { d: "M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3z" })),
        React.createElement("symbol", { id: "ssg-loader-icon__circle3" },
            React.createElement("path", { d: "M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3z" })),
        React.createElement("use", { className: "ssg-loader-icon__circle", href: "#ssg-loader-icon__circle1" }),
        React.createElement("use", { className: "ssg-loader-icon__circle ssg-loader-icon__circle--second", href: "#ssg-loader-icon__circle2" }),
        React.createElement("use", { className: "ssg-loader-icon__circle ssg-loader-icon__circle--third", href: "#ssg-loader-icon__circle3" })));
});
export default LoaderIcon;
